module.exports = __webpack_public_path__ + "img/vsl-logo.c081df87.png";